export default function getArrowModifier(arrowElement) {
  return {
    name: 'arrow',
    options: {
      element: arrowElement
    }
  };
}
